import type { components } from 'admination-react/api-schema'
import { ApiError, fillPath, getJsonOrNull, sendJson } from '@/core/api/http'
import type { MassnahmeKopf } from './massnahme'

export const KOMPETENZBILANZIERUNG_DOKUMENT = "Kompetenzbilanzierung"

export const ABSCHNITT_KEYS = [
  'berufliche_ausgangssituation',
  'persoenliche_soziale_kompetenzen',
  'praktische_methodische_kompetenzen',
  'sprachliche_kompetenzen',
  'zusammenfassende_bewertung',
] as const

export type AbschnittKey = (typeof ABSCHNITT_KEYS)[number]

export type Abschnitte = Record<AbschnittKey, string>

export type GespeicherteAbschnitte = Abschnitte & {
  gespeichert_von_name?: string | null
  gespeichert_am?: string | null
  massnahme: MassnahmeKopf | null
}

const PATH = '/kompetenzbilanzierung/{coaching_id}'

export function erzeugeKompetenzbilanzierung(coachingId: string): Promise<Abschnitte> {
  return sendJson<Abschnitte>(fillPath(`${PATH}/erzeugen`, { coaching_id: coachingId }), 'POST', {})
}

export function getKompetenzbilanzierung(coachingId: string): Promise<GespeicherteAbschnitte | null> {
  return getJsonOrNull<GespeicherteAbschnitte>(fillPath(PATH, { coaching_id: coachingId }))
}

export async function speichereKompetenzbilanzierung(coachingId: string, abschnitte: Abschnitte): Promise<void> {
  await sendJson<void>(fillPath(PATH, { coaching_id: coachingId }), 'PUT', abschnitte)
}

export const NIVEAUS = ['A0', 'A1', 'A2', 'B1'] as const satisfies readonly Niveau[]

export type Niveau = components['schemas']['SprachniveauSetzen']['niveau']

export async function setzeSprachniveau(coachingId: string, niveau: Niveau): Promise<boolean> {
  const gespeichert = await sendJson<unknown>(fillPath(`${PATH}/sprachniveau`, { coaching_id: coachingId }), 'POST', { niveau })
  return gespeichert !== undefined
}

export function erzeugenFehlerText(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null
  if (error.status === 409) return "Die Kompetenzbilanzierung kann erst erstellt werden, wenn alle drei Bewertungsbögen vorliegen."
  if (error.status === 502) return "Die Kompetenzbilanzierung konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
  return null
}
